import React, { FC } from 'react';

import { useApolloClient } from '@apollo/react-hooks';

import { ForgeUIEnvironmentProvider } from '@atlassian/forge-ui/provider';
import { ForgeUIRenderer } from '@atlassian/forge-ui/ui';

import { ForgeUIExtensionProps } from '../../types';
import { FORGE_PRODUCT } from '../../utils/context';
import { getEnvironment } from '../../utils/environment';

export const ForgeUIExtension: FC<ForgeUIExtensionProps> = ({
  app,
  bridge,
  components,
  contextIds,
  coreData,
  currentUser,
  entryPoint,
  extensionData,
  locale,
  getContextToken,
  onInitialRender,
}) => {
  const { localId, workspaceId } = coreData;
  const apolloClient = useApolloClient();

  return (
    <ForgeUIEnvironmentProvider value={getEnvironment()}>
      <ForgeUIRenderer
        accountId={currentUser?.account_id}
        bridge={bridge}
        client={apolloClient}
        components={components}
        contextIds={contextIds}
        entryPoint={entryPoint}
        extension={app}
        extensionData={extensionData}
        getContextToken={getContextToken}
        localId={localId}
        locale={locale}
        // Style overrides for Custom UI modals
        modalStyles={{
          padding: '24px',
        }}
        onInitialRender={onInitialRender}
        product={FORGE_PRODUCT}
        workspaceId={workspaceId!}
      />
    </ForgeUIEnvironmentProvider>
  );
};
